import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VersionHistory } from 'companySettings/components/PartFinderVersionHistory';
import { useGetPartFinderProductTypeVersions } from 'companySettings/hooks';
import { IPartFinderProductType, IPartFinderProductTypeChanges } from 'companySettings/types';

import { PartFinderProductTypeCompare } from './PartFinderProductTypeCompare';
import { formatProductTypeChanges } from '../utils';

interface IProps {
  productType: IPartFinderProductType;
}

// The status pill of an open product type; it opens the published versions, two of which can be
// compared.
export const PartFinderProductTypeVersionHistory = ({ productType }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const {
    data: versions = [],
    isLoading,
    isError,
  } = useGetPartFinderProductTypeVersions(productType.id, isOpen);

  return (
    <VersionHistory
      status={productType.status}
      versionNumber={productType.versionNumber}
      versions={versions}
      isLoading={isLoading}
      isError={isError}
      errorMessage={t('errorTitlePartFinderProductTypeVersionsFetch')}
      formatChanges={(changes: IPartFinderProductTypeChanges, isPublish: boolean) =>
        formatProductTypeChanges(changes, t, isPublish)
      }
      renderCompare={(fromVersionId, toVersionId, isCompareOpen, onClose) => (
        <PartFinderProductTypeCompare
          fromVersionId={fromVersionId}
          toVersionId={toVersionId}
          isOpen={isCompareOpen}
          onClose={onClose}
        />
      )}
      onOpenChange={setIsOpen}
    />
  );
};
